export class FunctionHealthUnitStruct {
    public idHealthUnit: number;
    public function: string;
    public idReportFunctionHealthUnit: number;
}
